import {createApiClient } from '../../../services/ApiClient';

let api = createApiClient();

export function getDocumentTable(form_type: string, process_id: number) {
    return (dispatch: any) => {
        api.getDocumentsData(form_type, process_id, {
            success: (payload) => {
                dispatch({
                    type: 'GET_DOCUMENT_DATA',
                    payload
                });
            },
            error: () => {}
        });
    };
}

export function getStatusHistory(document_id: string) {
    return (dispatch: any) => {
        api.getStatusHistory(document_id, {
            success: (payload) => {
                dispatch({
                    type: 'GET_STATUS_HISTORY',
                    payload
                });
            },
            error: () => {}
        });
    };
}